<template>
    <CustomDialog v-model="visible" :defaultTitle="$t('staff_planning_v3.download_modal.title')" width="560px">
        <!-- CONTENT -->
        <template #content>
            <div class="ppv2-space-y-4">
                <div class="v3-section-title mb-2">
                    <span>{{ $t('staff_planning_v3.components.create_shift.planning') }}</span>
                </div>

                <div class="ppv2-border ppv2-border-black ppv2-border-opacity-[8%] ppv2-rounded-xl ppv2-overflow-hidden">
                    <PlanningTypeSelector
                        :selectedWeek="selectedWeek"
                        :type.sync="downloadForm.type"
                        :week-str="downloadForm.weekStr"
                        :can-show-month="canShowMonth"
                        :enabled-weeks-month-count="enabledWeeksMonthCount"
                        :enabled-weeks-perso-count="enabledWeeksPersoCount"
                    />

                    <div v-if="downloadForm.type === 'month' || downloadForm.type === 'custom'">
                        <WeekSelector
                            v-if="downloadForm.type === 'month'"
                            :title="$t('staff_planning_v3.main.published_upcoming_weeks')"
                            :weeks="nextMonthWeeks"
                            :selected.sync="downloadForm.weeks"
                            :show-disabled="true"
                        />

                        <WeekSelector
                            v-if="downloadForm.type === 'custom'"
                            :title="$t('staff_planning_v3.main.personalized_weeks')"
                            :weeks="personalizedWeeks"
                            :selected.sync="downloadForm.weeks"
                            :show-disabled="false"
                        />
                    </div>
                </div>

                <StaffSelector :staffs="modalStaffList" :selected.sync="downloadForm.staffs" />

                <NoteSection v-model="downloadForm.note" />
            </div>
        </template>

        <!-- ACTIONS -->
        <template #actions>
            <ModalActions
                @cancel="closeModal"
                @confirm="downloadPlanning"
                :type="'download'"
                :confirmLabel="$t('staff_planning_v3.components.download_planning.download')"
            />
        </template>
    </CustomDialog>
</template>

<script>
import PlanningTypeSelector from './PlanningTypeSelector.vue'
import WeekSelector from './WeekSelector.vue'
import StaffSelector from './StaffSelector.vue'
import NoteSection from './NoteSection.vue'
import ModalActions from './ModalActions.vue'
import CustomDialog from '../../../Shared/CustomDialog.vue'

export default {
    components: {
        PlanningTypeSelector,
        WeekSelector,
        StaffSelector,
        NoteSection,
        ModalActions,
        CustomDialog,
    },

    props: {
        value: Boolean,
        downloadForm: Object,
        nextMonthWeeks: Array,
        personalizedWeeks: Array,
        modalStaffList: Array,
        canShowMonth: {
            type: Boolean,
            default: true,
        },
        enabledWeeksMonthCount: {
            type: Number,
            default: 0,
        },
        enabledWeeksPersoCount: {
            type: Number,
            default: 0,
        },
        selectedWeek: {
            type: String,
            default: '',
        },
    },

    emits: ['input'],

    methods: {
        downloadPlanning() {
            this.$emit('download')
        },
        closeModal() {
            this.$emit('input', false)
        },
    },
    computed: {
        visible: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            },
        },
    },
}
</script>
